module.exports = __webpack_public_path__ + "static/media/icon_no_connection.0e7348db.png";